import React from "react";

export default class Home extends React.Component {
    componentDidMount = () => {
        this.props.router.push("/courses");
    };

    render() {
        return <div>Home</div>;
    }
}
